/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 */
define([], () => {
	'use strict';


	class BaseFeature {

		constructor(options) {
			this.content = options.content;
			this.dashboardAPI = options.dashboardAPI;
			console.debug('******* feature created');
		}

		initialize() {
			return Promise.resolve();
		}

		getAPI(){
			return {
				testAPI: () => {
					console.debug('hello from ' + this.content.getId());
				}
			};
		}
	}

	return BaseFeature;
});
